export const SET_SIDE_NAVIGATION_STATE = 'UI/SET_SIDE_NAVIGATION_STATE'; // eslint-disable-line
